/* eslint-disable */
import { EmptyMessage, IdentityMessage, } from '../util/messages';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Map as ImmutableMap } from 'immutable';
import { ResourceQueryResult } from '../util/services';
import { HttpClient } from '@angular/common/http';
import { BaseHttpService, ResourceHelper } from '../util/http-services';
/* eslint-enable */

export namespace DocumentText {

  export enum OrderField {
    ID,
    NAME,
    CODE,
    DOCUMENT_GROUP_NAME,
    UPDATE_TIME,
    CREATION_TIME
  }

  export class Keys {

    private static readonly ID = 'id';
    private static readonly NAME = 'name';
    private static readonly CODE = 'code';
    private static readonly DOCUMENT_GROUP_NAME = 'document_group_name';
    private static readonly UPDATE_TIME = 'update_time';
    private static readonly CREATION_TIME = 'creation_time';

    private static readonly orderFieldKeyMap: ImmutableMap<DocumentText.OrderField, string> = ImmutableMap.of(
      DocumentText.OrderField.ID, Keys.ID,
      DocumentText.OrderField.NAME, Keys.NAME,
      DocumentText.OrderField.CODE, Keys.CODE,
      DocumentText.OrderField.DOCUMENT_GROUP_NAME, Keys.DOCUMENT_GROUP_NAME,
      DocumentText.OrderField.UPDATE_TIME, Keys.UPDATE_TIME,
      DocumentText.OrderField.CREATION_TIME, Keys.CREATION_TIME,
    );

    public static toOrderFieldKey(field: DocumentText.OrderField): string {
      return Keys.orderFieldKeyMap.get(field)!;
    }

  }

}

export interface DocumentTextQuery {
}

export interface CreateDocumentTextRequest {
  code?: string;
  name: string;
  value: string;
  comment: string;
  document_group_id?: number;
  language_code?: string;
}

export interface UpdateDocumentTextRequest {
  id: number;
  name: string;
  code?: string;
  value: string;
  comment: string;
  document_group_id?: number;
  language_code?: string;
}

export interface DocumentText {
  id: number;
  name: string;
  code: string;
  value: string;
  comment: string;
  document_group_id: number;
  language_code: string;
  creation_time: string;
  update_time: string;
  disabled: boolean;
}

export interface DisableRequest extends IdentityMessage {
  disabled: boolean;
}

@Injectable()
export class DocumentTextService extends BaseHttpService {

  query(request: DocumentTextQuery): Observable<ResourceQueryResult<DocumentText>> {
    return this.http.get<ResourceQueryResult<DocumentText>>(this.url, this.parseParams(request));
  }

  get(request: IdentityMessage): Observable<DocumentText> {
    return this.http.get<DocumentText>(this.url + `${request.id}`);
  }

  setDisabled(request: DisableRequest): Observable<EmptyMessage> {
    return this.http.patch(this.url + `${request.id}/disabled`, request);
  }

  create(request: CreateDocumentTextRequest): Observable<EmptyMessage> {
    return this.http.post(this.url, request);
  }

  update(request: UpdateDocumentTextRequest): Observable<EmptyMessage> {
    return this.http.put(this.url + `${request.id}`, request);
  }

  constructor(private http: HttpClient, resourceHelper: ResourceHelper) {
    super(resourceHelper, '/documents/texts/');
  }
}
